import axios from "axios";
import * as Urls from "../constants/Urls";

export const feedback = (obj) => axios.post(Urls.FEEDBACK_URL,obj);

export const track = () => axios.get(Urls.TRACK_LIST_URL);

export const volunteers = () => axios.get(Urls.VOLUNTEER_GSHEET_URL);

export const stories = () => axios.get(Urls.STORY_LIST_GSHEET_URL);

